export const NAV_TYPES = {
  MENU_ARTICLE: 'article',
  MENU_CATEGORY: 'category',
  BREADCRUMBS: 'breadcrumbs',
  SCROLL: 'scroll',
  SEARCH_RESULT: 'search_result',
  INDEX_PAGE: 'index-page',
  CONTENT_LINK: 'content_link',
};

export const SEARCH_USER_ACTIONS = {
  CANCEL: 'exit_search',
  RESULT_CLICK: 'result_click',
  CLEAR_BUTTON_CLICK: 'clear_button_click',
};

export const TOGGLE_EXAMPLES_ACTIONS = {
  OPEN: 'open',
  CLOSE: 'close',
};

export const NAVIGATION_BI_EVENT_TIMEOUT = 5000;
